import { render } from "./OrderSalesList.vue?vue&type=template&id=11750222"
import script from "./OrderSalesList.vue?vue&type=script&lang=js"
export * from "./OrderSalesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__